const errorName = {
    'networkError': 'Oops! No connection with server, Try again.',
    '404Error': '404 Error ! Page not found.',
    'internalError': 'Oops ! Something went wrong, Please login again.',
    'authenticationError': 'Oops! You can not access this page, Please login to continue.',
    'userNotFound': 'Oops! You do not have any account, Please create user account',
    'tooManyRequest': 'Oops! Too many request',
    'notNormalUser': 'You do not have normal user account !',
    'invalidPage': 'Invalid page !',
    'noData': 'No data found !',
}

const pattern = {
    'username_pattern': /^[a-zA-Z0-9@!_$ ]+$/,
    'email_pattern': /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    'entier_numeric': /^[0-9]+$/
}

const app_name = 'Ahilya Handlooms'
const phone_number_1 = 6260829322
const phone_number_2 = 8319748630
const whatsapp_number_1 = 6260829322
const whatsapp_number_2 = 8319748630
const email = 'ahilyahandlooms.in@gmail.com'
const instagram_link = 'https://www.instagram.com/ahilyahandlooms.in/'
const facebook_link = 'https://www.facebook.com/profile.php?id=61579082787451'
const whatsapp_channel_link = 'https://whatsapp.com/channel/0029VbBIOrQIyPtSpLdblV3E'
const whatsapp_link = 'https://chat.whatsapp.com/LHMYmli7ruNDGlUuFMndOf'



const url = process.env.REACT_APP_ENV === "production" ? 'https://ahilyahandlooms.in' : 'http://127.0.0.1:8000'

const path = {
    'home': '/',
    'create_user': '/user/createUser/',
    'login_user': '/user/loginUser/',
    'forgot_password': '/user/forgotPassword/',
    'user_profile': '/user/userProfile/',
    'all_address': '/user/address/all/',
    'add_address': '/user/address/add',
    'update_address': '/user/address/:id/details/',
    'wishlist': '/user/wishList/',
    'product_detail': '/product/:slug/details/',
    'all_product': '/p/shop/:shop__slug/category/:category__slug/products/',
    'all_shop': '/shop/all/',
    'shop_detail': '/shop/:slug/details/',
    'cart': '/cart/',
    'product_search': '/product/search/',
    'about': '/about/',
    'contact_us': '/contactUs/',
    'policies': '/policies/',
    'termsofservice': '/terms-service/',
    'all_order': '/order/all/',
    'order_detail': '/order/:id/details/',
    'order_placed': '/order-placed/',
    'install': '/install',
    'payment': '/payment/',
    'all_inquiry': '/inquiry/all/',
    'inquiry_detail': '/inquiry/:id/details/',
    'inquiry_cart': '/inquiryCart/',
    'inquiry_submited': '/inquiry-submited/',
    'tour_guide': '/tour-guide/',
    'buy_now': '/product/:id/buynow/',
    // demo
    'demo_category' : '/demo/category/'
}

const important_links = [
    { 'name': 'Home', 'link': path.home },
    { 'name': 'Products', 'link': '/p/shop/all/category/all/products/' },
    { 'name': 'Search Products', 'link': path.product_search },
    { 'name': 'Shops', 'link': path.all_shop },
    { 'name': 'About', 'link': path.about },
    { 'name': 'Contact Us', 'link': path.contact_us },
    { 'name': 'Policies', 'link': path.policies },
    { 'name': 'Terms Of Service', 'link': path.termsofservice },
    { 'name': 'Tour & Guide', 'link': path.tour_guide },
]

const static_img_url = process.env.REACT_APP_ENV === "production" ? 'https://ahilyahandlooms.in/static' : "/images"
const fallbackImg = process.env.REACT_APP_ENV === "production" ? 'https://ahilyahandlooms.in/static/fallback_image.webp' : '/images/fallback_image.webp'
const vidoeThumbnail = process.env.REACT_APP_ENV === "production" ? 'https://ahilyahandlooms.in/static/videothumbnail.webp' : '/images/videothumbnail.webp'
const defaultMetaTagImage = process.env.REACT_APP_ENV === "production" ? 'https://ahilyahandlooms.in/static/default_meta_tag_image.webp' : '/images/default_meta_tag_image.webp'

const max_price = 30000
const min_price = 500
const delivery_charge = 0

const base_loading_time = 500
const intersection_threshold = 0.3

const productSharingMessage = `Check out this amazing product on *AhilyaHandlooms.in* ! -

🪔 *100% Authentic & Original Handwoven Maheshwari Sarees | 🌍 Free Home Delivery | 🎉 Super Discount | 🧵 Direct from the handlooms of Maheshwar*

🛒 Buy this product in 3 simple steps:  

1️⃣ Create a new account or just log in  

2️⃣ Open product link → click *Add to Cart* (or Save to Wishlist for later)  

3️⃣ Go to Cart → change quantity if needed → add address → Place Order ✅

👉 *Order Now*:
`
function shopSharingMessage(shop_name) {
    return `✨*${shop_name}* is now Online at *AhilyaHandlooms.in* ✨
    
Now, Shop 100% Authentic & Original Handwoven Maheshwari Sarees Online, in just few steps - 
  
1️⃣ Visit the url & create your free account or just log-in to it.

2️⃣ Explore → Search → Filter → Sort and find your favorite products.

3️⃣ Click *Add To Cart* or *Save to Wishlist* for later.

4️⃣ Go to Cart → change quantity if needed → add address → Place Order. 

*Extra Benefits* -

✅ Free & Secure Home Delivery Across India.

✅ Wide Range of Products with Multiple Categories at one place.

✅ Features like Smart Filters, Sort By, Search Options etc.

✅ Great Discounts & Offers.

Let's Experience a new way to shop Maheshwari weaves online with *AhilyaHandlooms.in*

*explore now* -
`
}

const pageSharingMessage = `✨ Celebrate Every Occasion in Maheshwari Elegance ✨

*Handwoven with love❣️, inspired by the legacy of Ahilya Bai Holkar*

✅ 100% Authentic & Original Handwoven Maheshwari Sarees

✅ Direct from the Weavers of Maheshwar

✅ Grace of Silk, Strength of Cotton — a Timeless Blend

✅ Multiple Categories, Smart Filters & Searching Options

✅ Free & Secure Home Delivery Across India

✨ Every thread tells a story, every saree drapes elegance.

*explore now* -
`
// ✅ *Special Feature* — If the displayed product images and details aren’t enough, just message or call us. We will provide extra images, videos, or can do a live video — so you can buy with full confidence.
// const pageSharingMessage = 'Check out this amazing page on Ahilya Handlooms ! - '

const shopOption = ['all', 'Prachi Handloom', 'Shravanekar Handloom', 'Bhaavik Handloom']
const categoryOption = ['all',
    'Maheshwari Bagh Print Sarees',
    'Maheshwari 75% Silk Sarees',
    'Maheshwari Zari-Jari Checks Sarees',
    'Maheshwari Tissue Silk Sarees',
    'Garbha Reshami Silk Sarees',
    'Maheshwari Dabu Print Sarees',
    'Maheshwari Buta-Buti & Buti Sarees',
    'Maheshwari Multi Shaded Sarees',

    'Maheshwari Multi Coloured Border Sarees',
    'Maheshwari Resham Border Sarees',
    'Ganga Jamuna Border Sarees',
    'Maheshwari Bada Chhota Border Sarees',
    'Maheshwari Small Border Sarees',
    'Maheshwari Zari-Jari Border Sarees',

    'Maheshwari Jaal Pallu Sarees',
    'Maheshwari Jute Pallu Sarees',
    'Maheshwari Zari-Jari Pallu Sarees',

    'Maheshwari Silk Dupattas',
    'Maheshwari Handblock Print Suits'
]

const kotak_upi_id = '6260829322@kotak'

const orderStatus = {
    'Checking Stock': 'Checking & Arranging Stock',
    'Payment Pending': 'Stock Confirmed & Awaiting Payment',
    'Payment Done': 'Payment Received – Preparing for Dispatch',
    'Order Dispatched': 'Order Dispatched to Our Logistics Partner',
    'On The Way': 'Your Order is On the Way',
    'Delivered': 'Delivered to Your Doorstep'
}

export default errorName;
export { path, pattern, base_loading_time, fallbackImg, delivery_charge, min_price, defaultMetaTagImage, vidoeThumbnail, url, important_links, shopOption, max_price, categoryOption, static_img_url, app_name, phone_number_1, phone_number_2, whatsapp_number_1, whatsapp_number_2, instagram_link, facebook_link, whatsapp_channel_link, whatsapp_link, email, intersection_threshold, productSharingMessage, kotak_upi_id, pageSharingMessage, shopSharingMessage, orderStatus }